import {
  IBasicMeasureInput,
  IBasicSimpleMeasureInput,
  IMeasureDisplayFormatInput,
  ISimpleMeasureFieldsFragment,
  ISimpleMeasureInput,
  MeasureType,
  MeasureVersionType,
} from '../../../../../utils/apollo/graphqlSchema';
import { prepareRollingControlInput } from '../../../../../utils/builder/measures/inputs/utils';
import { parseEventConditionToInput } from '../../../../Builder/utils/builderUtils';
import { ISaveMeasureInputs } from './types';

const prepareBasicSimpleMeasureInput = (
  simpleMeasure: ISimpleMeasureFieldsFragment,
  schemaId: string,
): IBasicSimpleMeasureInput => {
  const eventConditions = simpleMeasure.eventConditions;

  return {
    eventConditions: eventConditions.map((eventCondition) =>
      parseEventConditionToInput(eventCondition, schemaId, true),
    ),
    formula: null,
    function: simpleMeasure.function.key,
    percentile: simpleMeasure.percentile,
  };
};

const prepareSimpleMeasureInput = (
  measures: ISimpleMeasureFieldsFragment[],
  schemaId: string,
): ISimpleMeasureInput[] =>
  measures.map((simpleMeasure) => {
    const { varName, version } = simpleMeasure;

    if (version?.versionId) {
      return {
        basicMeasure: null,
        namedMeasure: {
          versionId: version.versionId,
        },
        type: MeasureVersionType.Named,
        varName,
      };
    } else {
      return {
        basicMeasure: prepareBasicSimpleMeasureInput(simpleMeasure, schemaId),
        namedMeasure: null,
        type: MeasureVersionType.Basic,
        varName,
      };
    }
  });

/**
 * In order to Create or Update existing measure, based on different inputs -
 * function will prepare a BasicMeasureInput.
 *
 * There are 2 ways: simple and compound.
 *
 * The whole logic is based on simple measures (ISimpleMeasureFieldsFragment).
 *
 * In order to save a Compound measure it is required to provide a formula!
 * For simple measure formula is optional
 */
export const prepareBasicMeasureInput = (
  inputs: ISaveMeasureInputs,
  schemaId: string,
  format: IMeasureDisplayFormatInput | null,
): IBasicMeasureInput => {
  if (inputs.type === 'simple') {
    const { simpleMeasure, formulaExpression } = inputs;

    const basicSimpleMeasureInput = prepareBasicSimpleMeasureInput(
      simpleMeasure,
      schemaId,
    );

    return {
      compound: null,
      rollingControl: prepareRollingControlInput(simpleMeasure?.rollingControl),
      simple: {
        ...basicSimpleMeasureInput,
        formula: formulaExpression,
      },
      type: MeasureType.Simple,
      format,
    };
  } else {
    const { measures, formulaExpression } = inputs;

    return {
      compound: {
        measures: prepareSimpleMeasureInput(measures, schemaId),
        formula: formulaExpression,
      },
      rollingControl: null,
      simple: null,
      type: MeasureType.Compound,
      format,
    };
  }
};
